// Navbar.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [user, setUser] = useState(localStorage.getItem('user'));
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setUser(localStorage.getItem('user'));
    };

    window.addEventListener('storageChange', handleStorageChange);
    return () => window.removeEventListener('storageChange', handleStorageChange);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
    window.location.reload();
  };

  return (
    <header style={styles.header}>
      <div style={styles.headerContainer}>
        <div style={styles.headerContent}>
          {/* Logo */}
          <div style={styles.logo}>
            <Link to="/" style={styles.logoLink}>
              <img 
                src="https://swapiify.com/wp-content/uploads/2025/02/swapiify-1-1.png" 
                alt="Swapiify" 
                style={styles.logoImage}
              />
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <nav style={styles.nav}>
            <Link to="/" style={styles.navLink}>Home</Link>
            <Link to="/about" style={styles.navLink}>About Us</Link>
            <Link to="/products" style={styles.navLink}>Products</Link>
            <Link to="/contact" style={styles.navLink}>Contact Us</Link>
          </nav>
          
          {/* Desktop Actions */}
          <div style={styles.headerActions}>
            {user ? (
              <>
                <Link to="/dashboard" style={styles.dashboardLink}>
                  Dashboard
                </Link>
                <button 
                  onClick={handleLogout} 
                  style={styles.logoutButton}
                >
                  Logout
                </button>
              </>
            ) : (
              <Link to="/login" style={styles.loginButton}>
                Sign up / Log in
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button 
            style={styles.mobileMenuButton}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span style={styles.menuIcon}>☰</span>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div style={styles.mobileMenu}>
            <Link to="/" style={styles.mobileNavLink} onClick={() => setIsMobileMenuOpen(false)}>Home</Link>
            <Link to="/aboutus" style={styles.mobileNavLink} onClick={() => setIsMobileMenuOpen(false)}>About Us</Link>
            <Link to="/products" style={styles.mobileNavLink} onClick={() => setIsMobileMenuOpen(false)}>Products</Link>
            <Link to="/contactus" style={styles.mobileNavLink} onClick={() => setIsMobileMenuOpen(false)}>Contact Us</Link>
            
            {user ? (
              <>
                <Link to="/dashboard" style={styles.mobileNavLink} onClick={() => setIsMobileMenuOpen(false)}>Dashboard</Link>
                <button 
                  onClick={() => {
                    handleLogout();
                    setIsMobileMenuOpen(false);
                  }} 
                  style={styles.mobileLogoutButton}
                >
                  Logout
                </button>
              </>
            ) : (
              <Link to="/login" style={styles.mobileLoginButton} onClick={() => setIsMobileMenuOpen(false)}>
                Sign up / Log in
              </Link>
            )}
          </div>
        )}
      </div>
    </header>
  );
}

const styles = {
  header: {
    backgroundColor: '#fff',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },
  headerContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '15px 0',
  },
  logo: {
    flex: '0 0 auto',
  },
  logoLink: {
    textDecoration: 'none',
  },
  logoImage: {
    height: '40px',
    width: 'auto',
  },
  nav: {
    display: 'flex',
    gap: '30px',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  navLink: {
    textDecoration: 'none',
    color: '#333',
    fontWeight: '500',
    fontSize: '16px',
    transition: 'color 0.3s ease',
    ':hover': {
      color: '#702963',
    },
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    flex: '0 0 auto',
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  loginButton: {
    padding: '8px 20px',
    backgroundColor: 'transparent',
    border: '2px solid #702963',
    color: '#702963',
    borderRadius: '4px',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '14px',
    transition: 'all 0.3s ease',
    ':hover': {
      backgroundColor: '#702963',
      color: '#fff',
    },
  },
  dashboardLink: {
    padding: '8px 16px',
    backgroundColor: 'transparent',
    color: '#333',
    textDecoration: 'none',
    fontWeight: '500',
    fontSize: '14px',
    transition: 'color 0.3s ease',
    ':hover': {
      color: '#702963',
    },
  },
  logoutButton: {
    padding: '8px 16px',
    backgroundColor: 'transparent',
    border: 'none',
    color: '#333',
    fontWeight: '700',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    ':hover': {
      color: '#702963',
    },
  },
  mobileMenuButton: {
    display: 'none',
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#333',
    '@media (max-width: 768px)': {
      display: 'block',
    },
  },
  mobileMenu: {
    display: 'none',
    flexDirection: 'column',
    gap: '0',
    padding: '20px 0',
    borderTop: '1px solid #eee',
    '@media (max-width: 768px)': {
      display: 'flex',
    },
  },
  mobileNavLink: {
    textDecoration: 'none',
    color: '#333',
    fontSize: '16px',
    padding: '12px 0',
    borderBottom: '1px solid #eee',
    transition: 'color 0.3s ease',
    ':hover': {
      color: '#702963',
    },
  },
  mobileLoginButton: {
    padding: '12px 20px',
    backgroundColor: 'transparent',
    border: '2px solid #702963',
    color: '#702963',
    borderRadius: '4px',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '14px',
    textAlign: 'center',
    marginTop: '10px',
    transition: 'all 0.3s ease',
    ':hover': {
      backgroundColor: '#702963',
      color: '#fff',
    },
  },
  mobileLogoutButton: {
    padding: '12px 20px',
    backgroundColor: 'transparent',
    border: '2px solid #333',
    color: '#333',
    borderRadius: '4px',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '14px',
    textAlign: 'center',
    marginTop: '10px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    ':hover': {
      backgroundColor: '#333',
      color: '#fff',
    },
  },
};